export interface RetailAdInfo {
  ad_slot_id: number;
  ad_slot_name: string;
  ad_placement_id: number;
  ad_placement_name: string;
  ad_executable_id: number;
  ad_executable_name: string;
  ad_supplier: string | null;
  creative_type: number;
  creative_media_link: string;
  creative_link: string;
  creative_media_ratio: number | null;
}

export interface GetRetailAdResponse {
  ad_response_type: number;
  ad_info: RetailAdInfo | null;
}

export const AD_RESPONSE_TYPE = {
  OK: 100,
  NO_AD: 0,
  DISABLED_SLOT: 1,
  INVALID_CREATIVE: 2,
} as const;

export const CREATIVE_TYPE = {
  IMAGE: 1000,
  VIDEO: 2000,
} as const;

export const RETAIL_AD_SLOT_ID = {
  SEARCH: 201,
  OVERVIEW_TOP_BANNER: 501,
} as const;
